import axios from "axios";

// Construct base URL properly for relative or absolute URLs
const baseURL = process.env.VUE_APP_SERVERIP && process.env.VUE_APP_SERVERPORT
  ? `${process.env.VUE_APP_SERVERIP}:${process.env.VUE_APP_SERVERPORT}/api`
  : '/api';

export default axios.create({
  baseURL: baseURL,
  withCredentials: true, // Include session cookies
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'x-xsrf-token',
  headers: {
    "Content-type": "application/json"
  }
});
